import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=58940a3a&scoped=true&"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58940a3a",
  null
  
)

export default component.exports